/** Dates as "yyyy-mm-dd", the form the API and date inputs use, worked in UTC so no time zone shifts a day. */

export function parseIso(iso: string): Date {
  const [y = 1970, m = 1, d = 1] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

export function toIso(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/** The first of the month `months` away from the month of `iso`. */
export function addMonths(iso: string, months: number): string {
  const date = parseIso(iso);
  return toIso(new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + months, 1)));
}

/**
 * The days a month view shows: six weeks from the Sunday on or before the 1st, so the grid is
 * always the same height. `inMonth` is false for the days of the months either side.
 */
export function monthGrid(monthIso: string): { iso: string; day: number; inMonth: boolean }[] {
  const first = parseIso(addMonths(monthIso, 0));
  const start = new Date(first);
  start.setUTCDate(1 - first.getUTCDay());
  return Array.from({ length: 42 }, (_, i) => {
    const date = new Date(start);
    date.setUTCDate(start.getUTCDate() + i);
    return {
      iso: toIso(date),
      day: date.getUTCDate(),
      inMonth: date.getUTCMonth() === first.getUTCMonth(),
    };
  });
}

/** "October 2026". */
export function monthTitle(monthIso: string): string {
  return parseIso(monthIso).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** "10/16/2026", as the browser's own date fields show it. */
export function shortUsDate(iso: string): string {
  return parseIso(iso).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  });
}
